// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================
   Countdown Timer Panel
========================= */

.countdown-panel {
    display: flex;
    flex-direction: column;
    align-items: center;

    min-width: 10rem;

    padding: 0.75rem 1rem;

    background: #1a1a1a;

    border: 3px solid #3f8cff;
    border-radius: 0.75rem;

    box-shadow:
        0 0 10px rgba(63, 140, 255, 0.5),
        0 0 20px rgba(63, 140, 255, 0.3);

    -webkit-user-select: none;

            user-select: none;
}

/* =========================
   Timer Title
========================= */

.countdown-panel-title {
    color: white;

    font-size: 0.85rem;
    font-weight: bold;

    text-transform: uppercase;
    letter-spacing: 1px;

    margin-bottom: 0.25rem;
}

/* =========================
   Timer Display
========================= */

.countdown-time {
    font-family: "Courier New", monospace;
    font-size: clamp(1.75rem, 4vw, 3rem);
    font-weight: bold;

    color: #00ff88;

    text-shadow:
        0 0 5px #00ff88,
        0 0 15px #00ff88;
}

/* =========================
   Warning State
========================= */

.countdown-time.warning {
    color: #ffcc00;

    text-shadow:
        0 0 5px #ffcc00,
        0 0 15px #ffcc00;
}

/* =========================
   Danger State
========================= */

.countdown-time.danger {
    color: #ff3333;

    text-shadow:
        0 0 5px #ff3333,
        0 0 15px #ff3333,
        0 0 30px #ff3333;

    animation: pulse 1s infinite;
}

/* =========================
   Control Buttons
========================= */

.countdown-controls {
    display: flex;
    gap: 0.5rem;
    margin-top: 0.75rem;
}

.countdown-controls button {
    border: none;
    border-radius: 6px;

    padding: 0.5rem 0.75rem;

    font-size: 0.85rem;
    font-weight: bold;

    cursor: pointer;

    transition: 0.2s ease;
}

.countdown-controls button:hover {
    transform: translateY(-1px);
}

.countdown-controls button:active {
    transform: scale(0.97);
}

.countdown-controls button:first-child {
    background: #3f8cff;
    color: white;
}

.countdown-controls button:nth-child(2) {
    background: #ffcc00;
    color: black;
}

.countdown-controls button:last-child {
    background: #ff3333;
    color: white;
}

/* =========================
   Pulse Animation

.countdown-controls {
    display: flex;
    gap: 0.5rem;
    margin-top: 0.75rem;
}

.countdown-controls button {
    border: none;
    border-radius: 6px;

    padding: 0.5rem 0.75rem;

    font-size: 0.85rem;
    font-weight: bold;

    cursor: pointer;

    transition: 0.2s ease;
}

.countdown-controls button:hover {
    transform: translateY(-1px);
}

/* =========================
   Tablet
========================= */

@media (max-width: 768px) {
    .countdown-panel {
        min-width: 8rem;
        padding: 0.5rem 0.75rem;
    }

    .countdown-panel-title {
        font-size: 0.75rem;
    }

    .countdown-controls {
        flex-wrap: wrap;
        justify-content: center;
    }
}

/* =========================
   Mobile
========================= */

@media (max-width: 480px) {
    .countdown-panel {
        min-width: 6rem;

        padding: 0.5rem;

        border-width: 2px;
    }

    .countdown-panel-title {
        display: none;
    }

    .countdown-time {
        font-size: 2rem;
    }

    .countdown-controls {
        width: 100%;
    }

    .countdown-controls button {
        flex: 1 1;
        min-width: 60px;
        padding: 0.4rem;
        font-size: 0.75rem;
    }
}

`, "",{"version":3,"sources":["webpack://./src/css/countdownTimer.css"],"names":[],"mappings":"AAAA;;2BAE2B;;AAE3B;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;;IAEnB,gBAAgB;;IAEhB,qBAAqB;;IAErB,mBAAmB;;IAEnB,yBAAyB;IACzB,sBAAsB;;IAEtB;;wCAEoC;;IAEpC,yBAAiB;;YAAjB,iBAAiB;AACrB;;AAEA;;2BAE2B;;AAE3B;IACI,YAAY;;IAEZ,kBAAkB;IAClB,iBAAiB;;IAEjB,yBAAyB;IACzB,mBAAmB;;IAEnB,sBAAsB;AAC1B;;AAEA;;2BAE2B;;AAE3B;IACI,qCAAqC;IACrC,oCAAoC;IACpC,iBAAiB;;IAEjB,cAAc;;IAEd;;wBAEoB;AACxB;;AAEA;;2BAE2B;;AAE3B;IACI,cAAc;;IAEd;;wBAEoB;AACxB;;AAEA;;2BAE2B;;AAE3B;IACI,cAAc;;IAEd;;;wBAGoB;;IAEpB,4BAA4B;AAChC;;AAEA;;2BAE2B;;AAE3B;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,kBAAkB;;IAElB,uBAAuB;;IAEvB,kBAAkB;IAClB,iBAAiB;;IAEjB,eAAe;;IAEf,qBAAqB;AACzB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2BA6B2B;;AAE3B;IACI;QACI,eAAe;QACf,uBAAuB;IAC3B;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,uBAAuB;IAC3B;AACJ;;AAEA;;2BAE2B;;AAE3B;IACI;QACI,eAAe;;QAEf,eAAe;;QAEf,iBAAiB;IACrB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,SAAO;QACP,eAAe;QACf,eAAe;QACf,kBAAkB;IACtB;AACJ","sourcesContent":["/* =========================\n   Countdown Timer Panel\n========================= */\n\n.countdown-panel {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n\n    min-width: 10rem;\n\n    padding: 0.75rem 1rem;\n\n    background: #1a1a1a;\n\n    border: 3px solid #3f8cff;\n    border-radius: 0.75rem;\n\n    box-shadow:\n        0 0 10px rgba(63, 140, 255, 0.5),\n        0 0 20px rgba(63, 140, 255, 0.3);\n\n    user-select: none;\n}\n\n/* =========================\n   Timer Title\n========================= */\n\n.countdown-panel-title {\n    color: white;\n\n    font-size: 0.85rem;\n    font-weight: bold;\n\n    text-transform: uppercase;\n    letter-spacing: 1px;\n\n    margin-bottom: 0.25rem;\n}\n\n/* =========================\n   Timer Display\n========================= */\n\n.countdown-time {\n    font-family: \"Courier New\", monospace;\n    font-size: clamp(1.75rem, 4vw, 3rem);\n    font-weight: bold;\n\n    color: #00ff88;\n\n    text-shadow:\n        0 0 5px #00ff88,\n        0 0 15px #00ff88;\n}\n\n/* =========================\n   Warning State\n========================= */\n\n.countdown-time.warning {\n    color: #ffcc00;\n\n    text-shadow:\n        0 0 5px #ffcc00,\n        0 0 15px #ffcc00;\n}\n\n/* =========================\n   Danger State\n========================= */\n\n.countdown-time.danger {\n    color: #ff3333;\n\n    text-shadow:\n        0 0 5px #ff3333,\n        0 0 15px #ff3333,\n        0 0 30px #ff3333;\n\n    animation: pulse 1s infinite;\n}\n\n/* =========================\n   Control Buttons\n========================= */\n\n.countdown-controls {\n    display: flex;\n    gap: 0.5rem;\n    margin-top: 0.75rem;\n}\n\n.countdown-controls button {\n    border: none;\n    border-radius: 6px;\n\n    padding: 0.5rem 0.75rem;\n\n    font-size: 0.85rem;\n    font-weight: bold;\n\n    cursor: pointer;\n\n    transition: 0.2s ease;\n}\n\n.countdown-controls button:hover {\n    transform: translateY(-1px);\n}\n\n.countdown-controls button:active {\n    transform: scale(0.97);\n}\n\n.countdown-controls button:first-child {\n    background: #3f8cff;\n    color: white;\n}\n\n.countdown-controls button:nth-child(2) {\n    background: #ffcc00;\n    color: black;\n}\n\n.countdown-controls button:last-child {\n    background: #ff3333;\n    color: white;\n}\n\n/* =========================\n   Pulse Animation\n\n.countdown-controls {\n    display: flex;\n    gap: 0.5rem;\n    margin-top: 0.75rem;\n}\n\n.countdown-controls button {\n    border: none;\n    border-radius: 6px;\n\n    padding: 0.5rem 0.75rem;\n\n    font-size: 0.85rem;\n    font-weight: bold;\n\n    cursor: pointer;\n\n    transition: 0.2s ease;\n}\n\n.countdown-controls button:hover {\n    transform: translateY(-1px);\n}\n\n/* =========================\n   Tablet\n========================= */\n\n@media (max-width: 768px) {\n    .countdown-panel {\n        min-width: 8rem;\n        padding: 0.5rem 0.75rem;\n    }\n\n    .countdown-panel-title {\n        font-size: 0.75rem;\n    }\n\n    .countdown-controls {\n        flex-wrap: wrap;\n        justify-content: center;\n    }\n}\n\n/* =========================\n   Mobile\n========================= */\n\n@media (max-width: 480px) {\n    .countdown-panel {\n        min-width: 6rem;\n\n        padding: 0.5rem;\n\n        border-width: 2px;\n    }\n\n    .countdown-panel-title {\n        display: none;\n    }\n\n    .countdown-time {\n        font-size: 2rem;\n    }\n\n    .countdown-controls {\n        width: 100%;\n    }\n\n    .countdown-controls button {\n        flex: 1;\n        min-width: 60px;\n        padding: 0.4rem;\n        font-size: 0.75rem;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
